/* components/patterns/NavLink.jsx — пункт навигации (иконка + подпись + бейдж).
   Обёртка над RR.NavLink с активным состоянием через data-active. */

import React from 'react';
import { Icon } from '../ui/Icon.jsx';
import { RR } from '../../lib/router.jsx';

  const { NavLink: RRNavLink } = RR;
  const { useRef } = React;

  // ключ «прыжка» счётчика: меняется только при РОСТЕ числа (новый ответ), не при прочтении
  function useBumpKey(n) {
    const prev = useRef(n || 0);
    const key = useRef(0);
    if ((n || 0) > prev.current) key.current += 1;
    prev.current = n || 0;
    return key.current;
  }

  // badgeTone='accent' — счётчик-сигнал (новые ответы ассистента, #503): акцентный и с «прыжком»
  // при каждом новом значении (key); badgeLabel — текст для экранного диктора
  function NavItem({ to, icon, label, brand, badge, badgeTone, badgeLabel, end, collapsed, onClick, ...rest }) {
    const bump = useBumpKey(badgeTone ? badge : 0);
    return (
      <RRNavLink to={to} end={end} onClick={onClick} {...rest}
        className={({ isActive }) => 'nav-link' + (isActive ? ' is-active' : '')}>
        <span className="nav-link__icon"><Icon name={icon} size={20} /></span>
        <span className={'nav-link__label grow' + (brand ? ' argus-name' : '')}>{label}</span>
        {badge != null && badge > 0 && (
          <span key={badgeTone ? bump : undefined} aria-hidden={badgeLabel ? 'true' : undefined}
                className={'nav-link__badge num' + (badgeTone ? ` nav-link__badge--${badgeTone}` : '')}>{badge}</span>
        )}
        {badge != null && badge > 0 && badgeLabel && <span className="visually-hidden">{`, ${badgeLabel}`}</span>}
      </RRNavLink>
    );
  }

export { NavItem, useBumpKey };
